export const orderDataEdit = [
    {
        "customerType": "",
        "deliveryType": "delivery",
        "products": [
            {
                "product": 8,
                "count_product": "1",
                "priceProduct": "2100"
            },
            {
                "product": 4,
                "count_product": "1",
                "priceProduct": "321"
            },
            {
                "product": 14,
                "count_product": "1",
                "priceProduct": "12456"
            }
        ],
        "paymentType": "2",
        "date": "2021-9-5",
        "invoiceDateText": "2021-9-5",
        "invoiceDate": "2021-09-05T14:58:30.563Z",
        "klient": {
            "firstName": "Евгений",
            "lastName": "Перервенко",
            "patronymic": "Александрович",
            "phone": "+79205952527",
            "email": "uk091@yandex.ru"
        },
        "adresDelivery": "Белгород, Садовая, 59, под. , эт., кв.",
        "invoiceTimeDoText": "18:30",
        "invoiceTimeDo": "2021-09-05T15:30:30.571Z",
        "recipient": {
            "firstName": "Тест",
            "lastName": "Тестов",
            "patronymic": "Александрович",
            "phone": "+79205952527"
        },
        "klientHotel": "Пожелания клиента",
        "cardToOrder": "Напишите вот тот тот то",
        "managerComment": "Ниче не писать на карточке",
        "advance_type": "Наличные",
        "advance_sum": 100,
        "payment_type": "Наличные",
        "sdacha_sum_kupura": 1000,
        "sdacha_sum": 300,
        "discount_type": 1,
        "discount_value": "100",
        "itog_value": 12467,
        "fromKlient": 1,
        "social": 2,
        "social_text": "варпвпароапорвпа",
        "manager_zapolnil": 3,
        "manager_privlek": 4
    }
];